import React from 'react';
import {
    IconBulletListExtraLarge,
    IconClockXXL,
    IconHeartExtraLarge,
    IconPresentXXL,
} from '../../icons';

export const getDefaultList = ({ participationName } = {}) => [
    {
        icon: <IconBulletListExtraLarge />,
        text: <p>Entdecke die grösste Auswahl an {participationName} in deiner Nähe.</p>,
    },
    {
        icon: <IconHeartExtraLarge />,
        text: <p>Finde dank unseren Matching heraus, wie gut ein Pferd zu dir passt.</p>,
    },
    {
        icon: <IconClockXXL />,
        text: (
            <p>
                Bleibe zeitlich flexibel und melde dich für befristete oder langfriste Aushilfen an
            </p>
        ),
    },
    {
        icon: <IconPresentXXL />,
        text: <p>Nimm an exklusiven Gewinnspielen teil und erhalte tolle Prämien.</p>,
    },
];
